import _ from "lodash";
import qs from "query-string";
export default class Utils {
  constructor() {}
  isFavorite(nid, data) {
    let favoriteId = "";
    if (data) {
      data?.getFavorites?.body.forEach((element) => {
        if (element.nid == Number(nid)) {
          favoriteId = Number(nid);
        }
      });
    }
    return favoriteId;
  }
  getNotes(nid, data) {
    let notes = "";
    if (data) {
      data?.getFavorites?.body.forEach((element) => {
        if (element && element.nid == Number(nid)) {
          notes = element.notes;
        }
      });
      return notes;
    }
  }
  removeTags(htmlString) {
    return htmlString?.replaceAll(/<[^>]+>/g, "").replaceAll("&nbsp;", " ") ?? "";
  }
  difference(object, base) {
    let tmp = {};
    let keys = _.difference(Object.keys(object), Object.keys(base));
    keys.forEach((key) => {
      if (object[key] && object[key].length) {
        tmp[key] = object[key].toString();
      }
      if (base[key] && base[key].length) {
        tmp[key] = base[key].toString();
      }
    });
    return tmp;
  }

  setQueryStringValue(key, value, queryString = window.location.search) {
    const values = qs.parse(queryString);
    const newQsValue = qs.stringify({ ...values, [key]: value });
    return `?${newQsValue}`;
  }
  getQueryStringValue(key, queryString = window.location.search) {
    const values = qs.parse(queryString);
    return values[key];
  }
  isMobile() {
    return screen.width < 751;
  }
  setQueryStringWithoutPageReload(qsValue) {
    const newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      qsValue;

    window.history.pushState({ path: newurl }, "", newurl);
  }
  getParams() {
    var url = window.location.href;
    if(!url.includes('?')) return {};
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if(pair[1] && pair[1].indexOf('%') === -1) {
        params[pair[0]] = decodeURIComponent(pair[1]);        
      }
      else if(pair[1] && pair[1].indexOf('%') > -1) {
        params[pair[0]] = pair[1];        
      }
    }
    return params;
  }
  updateUrlString(single, obj) {
    const Params = new URLSearchParams(window.location.search);
    var url = window.location;
    const urlParams = this.getParams();
    if(!single) {
    let tmp = {};
    Object.keys(obj).forEach(key => {
    if((obj)[key].length) tmp[key] = obj[key].toString();
    else if (obj[key]) tmp[key] = obj[key];
    });
    var queryString = Object.keys(tmp).map(function(key) {
    return key + '=' + tmp[key];
    }).join('&');
    if(urlParams) {
    let obj2 = this.difference(urlParams, tmp);
    if(Object.keys(obj2).length > 0){
    queryString +='&';
    queryString += Object.keys(obj2).map(function(key) {
    if (Object.keys(obj).indexOf(key) === -1) return key + '=' + obj2[key];
    return '';
    }).join('&');
    }
    }
    url = url.origin + url.pathname + '?' + queryString ;
    } else {
    let current = Params.get(obj.key);
    let newSearch = obj.value;
    if(current){
    url = url.href.replace(obj.key+"="+current ,obj.key+"="+newSearch);
    }
    else {
    let newQuery = url.href.includes('?') ? '&': '?';
    newQuery += `${obj.key}=${newSearch}`;
    url = url + newQuery;
    }
    }
    window.history.pushState({path:url},'',url);
    localStorage.setItem('searchUrl', url);
    }
}

